export const ORDER_CHANNELS = ['shopify', 'amazon', 'sales', 'whatsapp', 'invoice', 'other'] as const;
export type OrderChannel = (typeof ORDER_CHANNELS)[number];
export type OrderStatus = 'open' | 'picking' | 'shipped' | 'cancelled';
export type TransferStatus = 'draft' | 'in_transit' | 'closed' | 'cancelled';
export type StickerKind = 'sku' | 'blank' | 'pallet';
export type ScanOutcome = 'accepted' | 'duplicate' | 'ignored' | 'rejected';
export type ActorType = 'user' | 'device' | 'system' | 'ai';
export type CountStatus = 'open' | 'finished' | 'cancelled';
export type DiscrepancyKind = 'missing' | 'unexpected' | 'transit_missing';
export const WRITE_OFF_REASONS = ['damaged', 'lost', 'sample', 'other'] as const;
export type WriteOffReason = (typeof WRITE_OFF_REASONS)[number];

/** Box and blank sticker sizes a company can print, in inches across × down. */
export const BOX_STICKER_SIZES = ['2.25x1.25', '4x2'] as const;
export type BoxStickerSize = (typeof BOX_STICKER_SIZES)[number];
/** Pallet sticker sizes. 4 × 2 in is for a company with only one roll in the printer. */
export const PALLET_STICKER_SIZES = ['4x6', '4x2'] as const;
export type PalletStickerSize = (typeof PALLET_STICKER_SIZES)[number];
export type AssistantTier = 'template' | 'net' | 'llm' | 'followup';
export type AssistantOutcome = 'answered' | 'asked' | 'unknown' | 'error';
export type AssistantChannel = 'whatsapp' | 'office';
export type AssistantAliasSource = 'derived' | 'admin' | 'learned';
export type AssistantAliasStatus = 'active' | 'pending' | 'rejected';
